import palette from './palette';

export const numberBox = {
  backgroundColor: 'primary.main',
  borderRadius: 0.5,
  color: 'common.white',
  display: 'inline-block',
  width: '20px',
  height: '20px',
  lineHeight: '20px',
  marginRight: 1,
  fontSize: '14px'
};

const standardBoxStyles = {
  display: 'flex',
  gap: 1,
  padding: 2,
  marginY: 1,
  border: 1,
  borderRadius: 2
};

export const infoBoxStyles = {
  ...standardBoxStyles,
  borderColor: palette.border,
  backgroundColor: palette.info.screen
};

export const warningBoxStyles = {
  ...standardBoxStyles,
  borderColor: palette.warning.dark,
  backgroundColor: palette.warning.background
};

export const cardBoxStyles = {
  ...standardBoxStyles,
  borderColor: palette.divider,
  backgroundColor: palette.background.paper
};

export const clickableCardBoxStyles = {
  ...cardBoxStyles,
  cursor: 'pointer',
  transition: 'background-color 0.2s, border-color 0.2s',
  '&:hover': {
    borderColor: palette.primary.main,
    backgroundColor: palette.primary.screen,
    '.card-arrow': {
      color: palette.primary.main
    }
  }
};

export const iconHighlightStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: palette.primary.light,
  borderRadius: 2,
  padding: 1
};
